import './SiteHeader.css';
import {useState, useEffect, useCallback} from 'react'
import '../../App.css';
import SphereLogo from "../../Assets/Images/SphereLogo.png";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import axios from 'axios';

import AccountPage from '../AccountPage/AccountPage'
import DownloadsPage from '../DownloadsPage/DownloadsPage'
import DocumentationPage from '../DocumentationPage/DocumentationPage';
import ManagePage from '../ManagePage/ManagePage';
import ContactPage from '../ContactPage/ContactPage'

/// Link (Navigation) Button
function LinkButton({name, link}) {
    return (
        <Link to={link}><button className='navigation-link'>{name}</button></Link>
    )
}

/// Contact Us Button
function ContactButton({link}) {
    return (
        <Link to={link}><button className='contact-button'> Contact Us! </button></Link>
    )
}


/// Check if Is Super user
function getIsSuperUser(setIsSuperUser) {
    const token = localStorage.getItem('token');
    axios.get('/api/isSuperUser/', {
        headers: {'Authorization': `Token ${token}`},
      })
      .then(reponse => {
          if (reponse.status === 200) {
              setIsSuperUser(reponse.data["isSuperUser"])
          }
          else {
            setIsSuperUser(false)
          }
      })
      .catch(error => {
          setIsSuperUser(false)
      })
}


/**
    Check on launch that the user is logged in, and if not, then log them out
    Because the users token might have timed out since the previous visit.
 */
async function isLoggedIn() {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get('/api/isLoggedIn/', {
            headers: {'Authorization': `Token ${token}`}
        })
        return response.status === 200;
    }
    catch {
        return false;
    }
}


/// Site Header
/// This will do all the navigation for the site. If adding a new link, add it here.
function SiteHeader() {
    const [isSuperUser, setIsSuperUser] = useState(false);

    const navigate = useNavigate()
    const logoutUser = useCallback(() => {
        const token = localStorage.getItem('token')
        axios.post('/api/tokenLogout/', {}, {
            headers: {'Authorization': `Token ${token}`},
          })
          .then(reponse => {
              if (reponse.status === 200) {
                navigate("/accounts")
                localStorage.setItem("token", '')
                localStorage.setItem("user", '')
                localStorage.setItem("creds", '')
                window.location.reload();
              }
          })
          .catch(error => {
            console.log(error)
            navigate("/accounts")
            localStorage.setItem("token", '')
            localStorage.setItem("user", '')
            localStorage.setItem("creds", '')
            window.location.reload();
          })
    }, [navigate])

    useEffect(()=> {
        document.title = 'Sphere Audio'
        isLoggedIn().then((status) => {
            if (!status)
                logoutUser();
            else
                getIsSuperUser(setIsSuperUser);
        })
    }, [logoutUser])


    /// Links
    // let howToLink = "/howto"
    let documentationLink = "/documentation"
    let downloadsLink = "/downloads"
    let accountLink = "/accounts"
    let isSuperUserLink = "/manage"
    let contactUsLink = "/contactUs"

    const superUserTag = isSuperUser ? (<LinkButton name="Manage" link={isSuperUserLink}/>) : (<></>);
    return (
        <div className='App'>
        <nav className="SiteHeader">
            <div className='navbar-left'>
                <Link to="/"><img src={SphereLogo} alt='' width={150} height={30}/></Link>
            </div>
            <div className='navbar-right'>
                <LinkButton name="Documentation" link={documentationLink}/>
                <LinkButton name="Downloads" link={downloadsLink}/>
                <LinkButton name="Account" link={accountLink}/>
                {superUserTag}
                <button className='navigation-link' onClick={logoutUser}>Logout</button>
                <ContactButton link={contactUsLink}/>
            </div>
        </nav>
         <Routes>
            <Route path={documentationLink} element={<DocumentationPage/>}/>
            <Route path={downloadsLink} element={<DownloadsPage/>}/>
            <Route path={accountLink} element={<AccountPage/>}/>
            <Route path={isSuperUserLink} element={<ManagePage/>}/>
            <Route path={contactUsLink} element={<ContactPage/>}/>
            <Route path='/' element={<AccountPage/>}/>
        </Routes>
        </div>
    )
}



export default SiteHeader;
